/**
 * Simple Markdown-to-HTML renderer for the AI chat.
 * Handles links, bold, inline code. Escapes HTML to prevent XSS.
 */
export function renderMarkdown(text: string): string {
  if (!text) return '';

  // Escape HTML first to prevent XSS
  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  // Convert Markdown links [Text](url) to HTML links
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_match: string, title: string, url: string) => {
    let fullUrl = url;
    if (url.startsWith('/')) {
      fullUrl = window.location.origin + url;
    }
    return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: underline; font-weight: 500;">${title}</a>`;
  });

  // Convert bold **text** to <strong>text</strong>
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

  // Convert inline code `code` to <code>code</code>
  html = html.replace(/`([^`]+)`/g, '<code style="background: rgba(0,0,0,0.1); padding: 2px 4px; border-radius: 4px;">$1</code>');

  return html;
}
